// import axios from 'axios';
// import { Message } from 'element-ui'; 
// import loadingObj from '../utils/globalLoading';
// import router from '../router';

// const service  = axios.create({
//     baseURL: process.env.VUE_APP_BASE_API,
//     headers: {
//         'Content-Type': 'application/json;charset=utf-8',
//       },
//     timeout: 3000000, // 设置请求超时时间
//     // timeout: 30000, // 设置请求超时时间
// })

// // 请求拦截器
// service.interceptors.request.use(config => {
//     const token = localStorage.getItem('token');
//     if (token){
//         config.headers.token = token;
//     }
//     loadingObj.showFullScreenLoading();
//     // config.headers.Authorization = `Bearer ${token}`;
//     return config
// }, 
// error =>{
//      loadingObj.tryHideFullScreenLoading();
//      Promise.reject(error)
// }

    
// );

// // 响应拦截器
// service.interceptors.response.use(
//     response => {
//         const {code, data, message} = response.data;
//         loadingObj.tryHideFullScreenLoading();
//         if (code === 200) {
//             return data
//         } else {
//             if(code === 400){
//                 localStorage.clear();
//                 router.push("/login")
//                 return 
//             }
//             // 提示错误信息
//             Message({
//                 message: message || '请求失败',
//                 type: 'error',
//                 customClass: 'global-message-zindex'  // 添加自定义样式类
//             });
//             return Promise.reject(new Error(message))
//         }
//     },
//     error => {
//         const { status, data } = error.response;
//         loadingObj.tryHideFullScreenLoading();
//          // 处理 HTTP 错误（如 401 跳转登录）
//         if (error.response?.status === 400) { // code = 400 没token
//             Message({
//                 message: '登录已过期',
//                 type: 'error',
//                 customClass: 'global-message-zindex'  // 添加自定义样式类
//             });
//             router.push('/login');
//             return
//         }
//             // 其他 HTTP 错误
//             Message({
//                 message: data.message || '请求失败',
//                 type: 'error',
//                 customClass: 'global-message-zindex'  // 添加自定义样式类
//             });
//         return Promise.reject(error);
//     }
// )

// export default service
import axios from 'axios';
import { Message } from 'element-ui'; 
import loadingObj from '../utils/globalLoading';
import router from '../router';

const service  = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
    },
    timeout: 3000000,
})

// 请求拦截器
service.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token){
        config.headers.token = token;
    }
    // 只有没标记noLoading才开启loading
    if (!config.noLoading) {
        loadingObj.showFullScreenLoading();
    }
    return config
}, 
error =>{
    loadingObj.tryHideFullScreenLoading();
    return Promise.reject(error) // 一定要加return
}
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        loadingObj.tryHideFullScreenLoading();
        // 文件流下载（responseType: 'blob'）拿到的不是 {code,data,message}，直接返回完整响应交给业务代码
        if (response.config && response.config.responseType === 'blob') {
            return response
        }
        const payload = response.data || {}
        const {code, data, message} = payload;
        if (code === 200) {
            return data
        } else {
            if(code === 400){
                localStorage.clear();
                router.push("/login")
                const err = new Error(message || '登录已过期，请重新登录')
                err._toastShown = true
                return Promise.reject(err)
            }
            // 提示错误信息
            Message({
                message: message || '请求失败',
                type: 'error',
                customClass: 'global-message-zindex'
            });
            const err = new Error(message || '请求失败')
            err._toastShown = true
            return Promise.reject(err)
        }
    },
    error => {
        loadingObj.tryHideFullScreenLoading();
        if (error.response?.status === 400) { 
            Message({
                message: '登录已过期',
                type: 'error',
                customClass: 'global-message-zindex'
            });
            router.push('/login');
            error._toastShown = true
            return Promise.reject(error);
        }
        // 没有 response 的情况（断网、超时、请求被中断）以前这里会再抛 TypeError，导致页面完全没提示
        let msg = '网络异常或服务不可用，请检查网络后重试'
        if (error.response) {
            const data = error.response.data
            if (data && typeof data === 'object' && (data.message || data.msg)) {
                msg = data.message || data.msg
            } else if (error.response.status) {
                msg = `请求失败（${error.response.status}）`
            }
        } else if (error.code === 'ECONNABORTED' || /timeout/i.test(error.message || '')) {
            msg = '请求超时，请稍后重试'
        }
        Message({
            message: msg,
            type: 'error',
            customClass: 'global-message-zindex'
        });
        error._toastShown = true
        return Promise.reject(error);
    }
)

export default service